import { render, staticRenderFns } from "./PackingScannQR.vue?vue&type=template&id=3bdad3b8"
import script from "./PackingScannQR.vue?vue&type=script&lang=js"
export * from "./PackingScannQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports